import React from "react";
import { Marker } from "react-leaflet";
import L from "leaflet";
import { getCardinalDirectionShort, typeDetails } from "../../utils/sensors.js";
import SensorPopup from "./SensorPopup.jsx";
import { useSensorsMap } from "../../contexts/SensorsMapProvider.jsx";
import { parseCustomDate } from "../../utils/dateUtils.js";

const SensorMarker = ({ group, handleMarkerClick }) => {
	const { state } = useSensorsMap();
	const hasSelectedSensor =
		state.selectedType && group.sensors.some((sensor) => sensor.type === state.selectedType);

	const getIconColor = (group) => {
		let lvd = null;
		let alert = 0;
		group.sensors.forEach((sensor) => {
			if (sensor.lvd) lvd = sensor.lvd;
			if (sensor.pre && sensor.pre < sensor.value) alert = 1;
			if (sensor.ale && sensor.ale < sensor.value) alert = 2;
			if (sensor.dan && sensor.dan < sensor.value) alert = 3;
		});

		if (alert === 1) return "#dec800";
		if (alert === 2) return "#de6400";
		if (alert === 3) return "#ff0000";

		if (!lvd) return "#4caf50";

		const lvdDate = parseCustomDate(lvd);
		const currentDate = new Date();
		const diffInHours = (currentDate - lvdDate) / (1000 * 60 * 60);

		if (diffInHours > 3) return "#666363";

		return "#015069";
	};

	if (state.selectedType && !hasSelectedSensor) return null;
	return (
		<Marker
			position={group.position}
			icon={
				hasSelectedSensor
					? (() => {
							const selectedSensor = group.sensors.find(
								(sensor) => sensor.type === state.selectedType
							);
							const value = selectedSensor?.value || "";
							const opacityStyle =
								selectedSensor?.lvd !== null ? "opacity: 0.8;" : "";
							const getColor = typeDetails[state.selectedType]?.getColor;
							const backgroundColor = getColor
								? getColor(
										value.split("_")[0],
										selectedSensor.pre,
										selectedSensor.ale,
										selectedSensor.dan
								  )
								: "#4caf50"; // Default green if no color logic

							if (value.includes("_")) {
								const [speed, direction] = value.split("_");

								return L.divIcon({
									className: "custom-sensor-icon",
									html: `
											<div style="
												position: relative;
												display: flex;
												align-items: center;
												justify-content: center;
												width: 40px;
												height: 40px;
												${opacityStyle}
											">
												<!-- Cerchio con valore -->
												<div style="
													width: 40px;
													height: 40px;
													background-color: ${backgroundColor};
													color: white;
													font-size: 12px;
													font-weight: bold;
													border-radius: 50%;
													display: flex;
													align-items: center;
													justify-content: center;
													position: relative;
												">
													${speed}
												</div>
												<!-- Freccia esterna (mostrata solo se speed > 0) -->
												${
													direction !== "nd"
														? `
												<div style="
													position: absolute;
													width: 0;
													height: 0;
													border-left: 10px solid transparent;
													border-right: 10px solid transparent;
													border-top: 10px solid black;
													transform: rotate(${direction}deg) translate(0, 25px);
													transform-origin: center;
												"></div>`
														: ""
												}
											</div>
										`,
									iconSize: [50, 50],
									iconAnchor: [25, 25],
								});
							}

							// Default case: Render the value as a rectangle
							return L.divIcon({
								className: "custom-sensor-icon",
								html: `
									<div style="
                                        width: 40px;
                                        height: 40px;
                                        background-color: ${backgroundColor};
                                        color: white;
                                        font-size: 12px;
                                        font-weight: bold;
                                        border-radius: 50%;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        position: relative;
										${opacityStyle}
                                    ">
										${value.split("_")[0]} ${
									!value.split("_")[1]
										? ""
										: getCardinalDirectionShort(value.split("_")[1])
										? `- ${getCardinalDirectionShort(value.split("_")[1])}`
										: ""
								}
									</div>
								`,
								iconSize: [50, 20],
								iconAnchor: [25, 10],
							});
					  })()
					: L.divIcon({
							className: "default-sensor-icon",
							html: `
							<div style="
								width: 20px;
								height: 20px;
								background-color: ${getIconColor(group)};

								border-radius: 50%;
								display: flex;
								align-items: center;
								justify-content: center;
							"></div>
						`,
							iconSize: [20, 20],
							iconAnchor: [10, 10],
					  })
			}
			eventHandlers={{
				click: () => handleMarkerClick(group),
			}}
		>
			<SensorPopup sensors={group.sensors} />
		</Marker>
	);
};

export default SensorMarker;
